import React from 'react';
import type {WithRouterProps} from 'react-router';

import sessionStore from 'client/Session/SessionStore';
import {requireSession} from 'lib/decorators/requireSession';

import {CALCULATOR_NAMES, CalculatorTypeAnnouncer} from './CalculatorTypeAnnouncer';

/**
 * Layout for the super-user-only `/calculator` route. Guarding the parent means
 * every calculator child, including ones added later, is covered without opting in.
 */
function CalculatorLayout({
  children,
  location
}: React.PropsWithChildren<Pick<WithRouterProps, 'location'>>): React.JSX.Element {
  // The layout stays mounted across /calculator/* pages, so its region is already in place
  // when a type switch changes the page.
  const calculatorType = location.pathname.split('/')[2]?.toLowerCase() ?? '';
  return (
    <>
      {children}
      <CalculatorTypeAnnouncer name={CALCULATOR_NAMES[calculatorType]} />
    </>
  );
}

export default requireSession({
  rolePredicate: () => sessionStore.isSuper()
})(CalculatorLayout);
